/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.PageInfo<defs.tms.ZoneTemplateResponseDto>>;
export function request(
  params: API.tms.zoneTemplate.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/zoneTemplate/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
